import { nbxVar } from '../../tokens/generated/nbx-tokens.js';
import { popoverTokens } from '../tokens/component-tokens/popover.tokens.js';
import { createCardTokens } from '../tokens/components.js';
import * as p from '../tokens/primitives.js';
import { SEMANTIC, type SemanticTokens } from '../tokens/semantic.js';

/**
 * Popover Component Configuration
 * Panel styled as the semantic `overlay.popover` (same surface, border and text as the select
 * overlay). Without it the preset emits no `--p-popover-*` variables and the panel is transparent.
 */
export function createPopover(s: SemanticTokens) {
  const card = createCardTokens(s);
  return {
    root: {
      background: s.surface.ground,
      borderColor: s.border.divider,
      color: s.text.secondary,
      borderRadius: p.borderRadius[8],
      shadow: nbxVar('shadow.overlay-sm'),
      gutter: popoverTokens.gutter,
      arrowOffset: popoverTokens.arrowOffset,
    },
    content: {
      padding: s.layout.padding.sm,
    },
    css: () => `
      .p-popover.nbx-filters-popover {
        --p-popover-gutter: ${card.filters.gutter};
        background: transparent;
        border: 0;
        border-radius: 0;
        padding: 0;
        box-shadow: none;
      }

      @media (max-width: ${card.filters.stackedBreakpoint}) {
        .p-popover.nbx-filters-popover {
          max-height: min(${card.filters.mobileMaxHeight}, calc(100dvh - ${p.spacing[32]}));
          overflow-y: auto;
        }
      }

      .p-popover.nbx-filters-popover .p-popover-content {
        padding: 0;
      }

      .p-popover.nbx-filters-popover::before,
      .p-popover.nbx-filters-popover::after {
        display: none;
      }

      .p-popover.nbx-filters-popover .p-multiselect-label.p-placeholder {
        color: ${s.text.secondary};
      }
    `,
  };
}
export const popover = createPopover(SEMANTIC);
